import { PureComponent } from "react";
import Picture from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { INDUSTRIES_CONFIG } from "services/industries/industries-service";

import { componentStyles } from "./industry-selection-second-step.scss";

export default class IndustrySelectionSecondStepComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="industry-selection-second-step-wrapper">
        <div className="done-gif-wrapper">
          <img src="/static/img/industry-selection/done.gif" />
        </div>
        <div className="signup-title"> That’s awesome!</div>
        <div className="signup-subtitle" dangerouslySetInnerHTML={{ __html: INDUSTRIES_CONFIG.signupHtmlSubTitle }} />

        <div className="signup-wrapper">
          <SignupFormComponent />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
